export default __webpack_public_path__ + "static/media/garanty.2be9c418.svg";